import { queryOptions } from '@tanstack/react-query';
import { getBodyVehicleInformationType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleInformation/getBodyVehicleInformation.type';
import { getBodyVehicleInformationFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleInformation/getBodyVehicleInformationFunction';

export const getBodyVehicleInformationOption = ({
  id,
}: getBodyVehicleInformationType) =>
  queryOptions({
    queryKey: ['patch-part_one-body-vehicle-information', id],
    queryFn: () => getBodyVehicleInformationFunction({ id }),
  });
